import styled from '@emotion/styled';

export const Icon = styled.span<{ fontSize: number }>`
  display: inline-flex;
  align-items: center;
  border-radius: 2em;
  padding: 0;
  position: relative;
  font-size: ${({ fontSize = 1 }) => `calc(1em * ${fontSize})`} !important;
  img {
    width: 100%;
    height: auto;
    aspect-ratio: 1/1
  }
}
`;
